export const API_URL = 'https://trc6.tpsre.api.dsml.ru/'
export const CONFIRMATION_GENERATOR_ID = 'b6f3adba-d3d8-415f-865e-60ac0b791c0b'
export const EMAIL_CONFIRMATION_GENERATOR_ID = '8a7f4d6a-d3d1-4471-84c1-471278677624'
export const PERSONAL_DATA_CONSENT_ID = '0567026c-194c-48aa-bad4-e99fdab6a651'
export const COMMUNICATIONS_CONSENT_ID = 'a0f1ece3-908c-4f39-8da4-32b1e3a55a19'
export const RULES_CONSENT_ID = 'bd609541-859b-4178-9971-739e6e396046'
export default API_URL



// WEBPACK FOOTER //
// ./src/common/config.js